// extracted by mini-css-extract-plugin
module.exports = {"root":"YouTubePlayer_root__YvlCF","caption":"YouTubePlayer_caption__Wr6Qc","player":"YouTubePlayer_player__JS2Vk","playButton":"YouTubePlayer_playButton__ZphKK"};